import { useApi } from '@hooks/useApi';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { MerchantUser } from '@root/globalTypes';

export function useGetMerchantUser(id: string) {
  const { query } = useApi();

  const { data, isPending } = useQuery<MerchantUser>({
    queryKey: [...queryKeys.merchantUsers, id],
    queryFn: (): Promise<MerchantUser> =>
      query({
        path: `v1/merchant/users/${id}`,
      }),
    enabled: Boolean(id),
  });

  return {
    data: data,
    isPending,
  };
}
